/**
 * Category Discount Service
 * Handles API calls for category discount management
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class CategoryDiscountService {
  // Get auth token
  getAuthToken() {
    const token = localStorage.getItem('adminToken');
    return token ? `Bearer ${token}` : '';
  }

  // Create discount
  async createDiscount(discountData) {
    try {
      const response = await axios.post(
        `${API_URL}/admin/category-discounts`,
        discountData,
        {
          headers: {
            'Authorization': this.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create discount' };
    }
  }

  // Get all discounts
  async getAllDiscounts(params = {}) {
    try {
      const response = await axios.get(`${API_URL}/admin/category-discounts`, {
        params,
        headers: {
          'Authorization': this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch discounts' };
    }
  }

  // Get single discount
  async getDiscount(id) {
    try {
      const response = await axios.get(`${API_URL}/admin/category-discounts/${id}`, {
        headers: {
          'Authorization': this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch discount' };
    }
  }

  // Update discount
  async updateDiscount(id, discountData) {
    try {
      const response = await axios.put(
        `${API_URL}/admin/category-discounts/${id}`,
        discountData,
        {
          headers: {
            'Authorization': this.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update discount' };
    }
  }

  // Delete discount
  async deleteDiscount(id) {
    try {
      const response = await axios.delete(`${API_URL}/admin/category-discounts/${id}`, {
        headers: {
          'Authorization': this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete discount' };
    }
  }

  // Toggle discount active status
  async toggleDiscount(id) {
    try {
      const response = await axios.patch(
        `${API_URL}/admin/category-discounts/${id}/toggle`,
        {},
        {
          headers: {
            'Authorization': this.getAuthToken()
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to toggle discount' };
    }
  }
}

export default new CategoryDiscountService();
